export * as mediaCollections from '@wix/auto_sdk_media-collections_media-collections/schemas';
